/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const FocusIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    onClick={props.onClick}
  >
    <g>
      <path d="M15.5,8.5 L23.5,0.5" />
      <path d="M0.5,23.5 L8.5,15.5" />
      <polyline points="20.5 8.5 15.5 8.5 15.5 3.5" />
      <polyline points="8.5 20.5 8.5 15.5 3.5 15.5" />
      <path d="M15.5,15.5 L23.5,23.5" />
      <path d="M0.5,0.5 L8.5,8.5" />
      <polyline points="15.5 20.5 15.5 15.5 20.5 15.5" />
      <polyline points="3.5 8.5 8.5 8.5 8.5 3.5" />
      <circle cx="12" cy="12" r="2" />
    </g>
  </svg>
);

export default FocusIcon;
